/** How many next-plan features a lower plan's card shows before the "+ N more" toggle. */
export const UPSELL_TEASER_COUNT = 2

/**
 * Splits a lower plan's "Available in <next plan>" list into the always-visible hook and
 * the rest behind a toggle. A hidden remainder of one item isn't worth a toggle, so it is
 * shown inline instead.
 */
export function splitUpsellTeaser<T>(
  items: readonly T[],
  count = UPSELL_TEASER_COUNT
): { shown: T[]; hidden: T[] } {
  if (items.length <= count + 1) return { shown: [...items], hidden: [] }
  return { shown: items.slice(0, count), hidden: items.slice(count) }
}
